import React, { useEffect, useState } from 'react';
import { X, Key, Save } from 'lucide-react';
import authService from '../../services/authService';
import './ChangePasswordDialog.css';

const ChangePasswordDialog = ({ isOpen, onClose, onPasswordChanged }) => {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    new_password_confirm: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setFormData({
        old_password: '',
        new_password: '',
        new_password_confirm: '',
      });
      setError(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.old_password || !formData.new_password || !formData.new_password_confirm) {
      setError('Tous les champs sont obligatoires.');
      return;
    }

    if (formData.new_password !== formData.new_password_confirm) {
      setError('La confirmation du nouveau mot de passe ne correspond pas.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await authService.changePassword(
        formData.old_password,
        formData.new_password,
        formData.new_password_confirm
      );

      if (onPasswordChanged) {
        await onPasswordChanged();
      }

      onClose();
    } catch (err) {
      const data = err.response?.data;
      const msg = data?.error || data?.detail || data?.new_password_confirm?.[0] || 'Erreur lors du changement de mot de passe';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !loading) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay ui-dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-container ui-dialog-container">
        <div className="dialog-header ui-dialog-header">
          <div className="dialog-title ui-dialog-title">
            <Key size={24} />
            <h2>Réinitialiser le mot de passe</h2>
          </div>
          <button className="dialog-close" onClick={onClose} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        {error && <div className="dialog-error">{error}</div>}

        <form className="dialog-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="old_password" className="ui-label">
              Mot de passe actuel
            </label>
            <input
              type="password"
              id="old_password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
              required
              className="ui-input"
              placeholder="Mot de passe actuel"
              autoComplete="current-password"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="new_password" className="ui-label">
                Nouveau mot de passe
              </label>
              <input
                type="password"
                id="new_password"
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                required
                className="ui-input"
                placeholder="Nouveau mot de passe"
                autoComplete="new-password"
              />
            </div>

            <div className="form-group">
              <label htmlFor="new_password_confirm" className="ui-label">
                Confirmation
              </label>
              <input
                type="password"
                id="new_password_confirm"
                name="new_password_confirm"
                value={formData.new_password_confirm}
                onChange={handleChange}
                required
                className="ui-input"
                placeholder="Confirmer"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="dialog-actions ui-dialog-actions">
            <button
              type="button"
              className="btn-secondary ui-btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn-primary ui-btn-primary"
              disabled={loading}
            >
              {loading ? 'Enregistrement...' : (
                <>
                  <Save size={18} />
                  Enregistrer
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordDialog;
